module.exports = __webpack_public_path__ + "static/media/SSM_DeanHealthPlan_Horz_RGB_No_R.ea534150.png";